/**
 * Centralized Setlist Song Store
 * 
 * Contains all 50 songs with metadata for simulation and display
 */

// Top 20 Priority Songs - These should dominate the top 10
export const TOP_20_PRIORITY = [
  {
    title: "REDBONE",
    priority: 1,
    era: "Awaken, My Love!",
    year: 2016,
    type: "single"
  },
  {
    title: "LES",
    priority: 2,
    era: "Camp",
    year: 2011,
    type: "album"
  },
  {
    title: "SOBER",
    priority: 3,
    era: "Kauai",
    year: 2014,
    type: "EP"
  },
  {
    title: "3005",
    priority: 4,
    era: "Because the Internet",
    year: 2013,
    type: "single"
  },
  {
    title: "SWEATPANTS",
    priority: 5,
    era: "Because the Internet",
    year: 2013,
    type: "single"
  },
  {
    title: "THIS IS AMERICA",
    priority: 6,
    era: "Singles",
    year: 2018,
    type: "single"
  },
  {
    title: "MYSTERY SONG COVER",
    priority: 7,
    era: "Live",
    year: 2024,
    type: "cover"
  },
  {
    title: "WHERE HAVE I BEEN? - MONOLOGUE",
    priority: 8,
    era: "Live",
    year: 2024,
    type: "monologue"
  },
  {
    title: "LITHONIA",
    priority: 9,
    era: "Bando Stone",
    year: 2024,
    type: "single"
  },
  {
    title: "BONFIRE",
    priority: 10,
    era: "Camp",
    year: 2011,
    type: "single"
  },
  {
    title: "ME AND UR MAMA",
    priority: 11,
    era: "Awaken, My Love!",
    year: 2016,
    type: "album"
  },
  {
    title: "HEARTBEAT",
    priority: 12,
    era: "Camp",
    year: 2011,
    type: "single"
  },
  {
    title: "URN",
    priority: 13,
    era: "Bando Stone",
    year: 2024,
    type: "single"
  },
  {
    title: "SURVIVE",
    priority: 14,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "TO BE HUNTED",
    priority: 15,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "PSILOCYBAE",
    priority: 16,
    era: "Singles",
    year: 2024,
    type: "single"
  },
  {
    title: "DO YA LIKE",
    priority: 17,
    era: "Kauai",
    year: 2014,
    type: "EP"
  },
  {
    title: "FREAKS AND GEEKS",
    priority: 18,
    era: "EP",
    year: 2011,
    type: "single"
  },
  {
    title: "HUMAN SACRIFICE",
    priority: 19,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "WORST GUYS",
    priority: 20,
    era: "Because the Internet",
    year: 2013,
    type: "album"
  }
];

// Songs 21-50 - Should occasionally break into top 10 but not dominate
export const REMAINING_SONGS = [
  {
    title: "H3@RT$ W3RE M3@NT T0 F7Y",
    priority: 21,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "CRUISIN",
    priority: 22,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "TALK MY SHIT",
    priority: 23,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "GOT 2 BE",
    priority: 24,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "IN THE NIGHT",
    priority: 25,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "YOSHINOYA",
    priority: 26,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "URN (FULL VERSION)",
    priority: 27,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "CRAWL",
    priority: 28,
    era: "Because the Internet",
    year: 2013,
    type: "album"
  },
  {
    title: "WE ARE GOD",
    priority: 29,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "FEELS LIKE SUMMER",
    priority: 30,
    era: "Singles",
    year: 2018,
    type: "single"
  },
  {
    title: "PLACE WHERE LOVE GOES",
    priority: 31,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "NO EXCUSES",
    priority: 32,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "REAL LOVE",
    priority: 33,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "DAMN RIGHT (JENNIE)",
    priority: 34,
    era: "Collaborations",
    year: 2024,
    type: "feature"
  },
  {
    title: "WITCHY (KAYTRANADA)",
    priority: 35,
    era: "Collaborations",
    year: 2019,
    type: "feature"
  },
  {
    title: "TELEGRAPH AVE",
    priority: 36,
    era: "Because the Internet",
    year: 2013,
    type: "album"
  },
  {
    title: "SUMMERTIME MAGIC",
    priority: 37,
    era: "Singles",
    year: 2018,
    type: "single"
  },
  {
    title: "THE PALISADES",
    priority: 38,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "BLACK QUALLS (THUNDERCAT)",
    priority: 39,
    era: "Collaborations",
    year: 2020,
    type: "feature"
  },
  {
    title: "RETRO (ROUGH)",
    priority: 40,
    era: "Kauai",
    year: 2014,
    type: "EP"
  },
  {
    title: "I. PINK TOES",
    priority: 41,
    era: "Because the Internet",
    year: 2013,
    type: "album"
  },
  {
    title: "TERRIFIED",
    priority: 42,
    era: "Awaken, My Love!",
    year: 2016,
    type: "album"
  },
  {
    title: "FAVORITE SONG (CHANCE)",
    priority: 43,
    era: "Because the Internet",
    year: 2013,
    type: "album"
  },
  {
    title: "BABY BOY",
    priority: 44,
    era: "Awaken, My Love!",
    year: 2016,
    type: "album"
  },
  {
    title: "WHAT KIND OF LOVE",
    priority: 45,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "DADVOCATE",
    priority: 46,
    era: "Bando Stone",
    year: 2024,
    type: "album"
  },
  {
    title: "STEPS BEACH",
    priority: 47,
    era: "Kauai",
    year: 2014,
    type: "EP"
  },
  {
    title: "RIOT",
    priority: 48,
    era: "Awaken, My Love!",
    year: 2016,
    type: "album"
  },
  {
    title: "LITTLE FOOT BIG FOOT",
    priority: 49,
    era: "Camp",
    year: 2011,
    type: "album"
  }
];

// Combined full setlist
export const FULL_SETLIST = [...TOP_20_PRIORITY, ...REMAINING_SONGS];

// Helper functions
export const getTop20Titles = () => TOP_20_PRIORITY.map(s => s.title);

export const getAllTitles = () => FULL_SETLIST.map(s => s.title);

export const getSongByTitle = (title) => FULL_SETLIST.find(s => s.title === title);

export const getSongsByEra = (era) => FULL_SETLIST.filter(s => s.era === era);

export const getSongsByType = (type) => FULL_SETLIST.filter(s => s.type === type);

/**
 * Initialize songs with proper totalVotes distribution
 * Top 20 get 10000 → 3000 votes (strong head start)
 * Songs 21-50 get 2800 → 200 votes (much lower)
 */
export const initializeSongsWithVotes = () => {
  return FULL_SETLIST.map((song) => {
    const { title, priority } = song;
    
    let score;
    let totalVotes;
    
    if (priority <= 20) {
      // Top 20: Strong head start for cumulative mode
      // Linear distribution: 10000 → 3000
      score = 1.0 - ((priority - 1) / 20) * 0.5;
      totalVotes = 10000 - ((priority - 1) / 20) * 7000;
    } else {
      // Songs 21-50: Much lower starting point
      // Linear distribution: 2800 → 200
      const adjustedIndex = priority - 21;
      score = 0.49 - (adjustedIndex / 30) * 0.48;
      totalVotes = 2800 - (adjustedIndex / 30) * 2600;
    }
    
    return {
      title,
      score: parseFloat(score.toFixed(4)),
      totalVotes: Math.round(totalVotes),
      rank: priority,
      ...song
    };
  });
};

/**
 * Calculate expected top 10 dominance percentage
 * How many of top 10 should be from top 20 priority list
 */
export const EXPECTED_TOP_10_DOMINANCE = 0.85; // 85% = 8.5/10 songs from top 20

// Export all setlist utilities as default
const setlistStore = {
  TOP_20_PRIORITY,
  REMAINING_SONGS,
  FULL_SETLIST,
  getTop20Titles,
  getAllTitles,
  getSongByTitle,
  getSongsByEra,
  getSongsByType,
  initializeSongsWithVotes,
  EXPECTED_TOP_10_DOMINANCE
};

export default setlistStore;
